import {
  normalizeOperatorIdForForm,
  normalizeOwnershipStatus,
} from "../constants/ownershipStatus";

/** Map ownership fields from a component API payload (any casing). */
export function mapComponentOwnershipFromApi(component: unknown) {
  const c = (component ?? {}) as Record<string, unknown>;
  return {
    ownershipStatus: normalizeOwnershipStatus(
      (c.ownershipStatus ?? c.OwnershipStatus ?? null) as number | string | null
    ),
    ownershipStatusLabel:
      (c.ownershipStatusLabel ?? c.OwnershipStatusLabel ?? null) as
        | string
        | null,
    operatorId:
      normalizeOperatorIdForForm(c.operatorId ?? c.OperatorId ?? null) || null,
    operatorName: (c.operatorName ?? c.OperatorName ?? null) as string | null,
    owner: (c.owner ?? c.Owner ?? null) as string | null,
  };
}

export function buildComponentOwnershipPayload(data: {
  attachedToAirframe?: string | null;
  attachmentLocation?: string | null;
  ownershipStatus?: number | string | null;
  operatorId?: unknown;
}) {
  const status = normalizeOwnershipStatus(data.ownershipStatus);
  const operatorId = normalizeOperatorIdForForm(data.operatorId);
  return {
    ownershipStatus: status === "" ? null : status,
    operatorId: operatorId || null,
  };
}
